import { AfterViewInit, Component, ComponentFactoryResolver, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Models } from '@ibexfusion/models';

import { FormTemplatesByImportType } from '../form-templates.map';
import { ImportModelsByType } from '../import-models.map';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { FormDirective } from '../../../directives/form/form.directive';
import { ImportService } from '@services/imports/import.service';
import { ImportTypeService } from '@services/import-types/import-type.service';
import { DefaultFormComponent } from '../../../components/default-form/default-form.component';
import { FormComponent } from '../../../components/default-form/form.component';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import * as _ from 'lodash';

@Component({
    selector: 'app-import-edit',
    templateUrl: './import-edit.component.html',
    styleUrls: ['./import-edit.component.scss'],
    providers: [ImportService, ImportTypeService],
    standalone: false
})
export class ImportEditComponent implements AfterViewInit {

  @ViewChild(FormDirective, { static: true }) formHost: FormDirective;

  isLoading = false;
  boundImport: Models.ImportBaseModel;
  boundImportId: string;

  importId: string;
  importTypeCustomId: string;

  title: any;

  options = { hideFields: true };

  public pageActions: PageAction[];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private snackbar: SnackbarService,
    private importService: ImportService,
    private importTypeService: ImportTypeService,
    private componentFactoryResolver: ComponentFactoryResolver
  ) {
    this.importId = this.route.snapshot.params['id'];
    this.createPageActions();
    this.isLoading = true;
    this.router.routeReuseStrategy.shouldReuseRoute = function() {
      return false;
    }
  }

  ngAfterViewInit() {
    this.importService.get(this.importId).then(importItem => {
      this.importTypeService.get(importItem.typeId).then(importTypeItem => {
        this.boundImportId = importItem.getId();
        this.importTypeCustomId = importTypeItem.customId;
        this.boundImport = <Models.ImportBaseModel>Models.ModelFactory.createModelInstanceByName(ImportModelsByType.get(this.importTypeCustomId), importItem);
        this.title = (this.boundImport ? this.boundImport.title : 'Edit importer');
        this.loadForm();
        this.isLoading = false;
      });
    });
  }

  loadForm() {
    const formItem = FormTemplatesByImportType.get(this.importTypeCustomId) || DefaultFormComponent;

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(formItem);

    const viewContainerRef = this.formHost.viewContainerRef;
    viewContainerRef.clear();

    const componentRef = viewContainerRef.createComponent(componentFactory);
    (<FormComponent>componentRef.instance).entry = this.boundImport;
    (<FormComponent>componentRef.instance).options = this.options;
  }

  onSave() {
    return this.boundImport.validate(true).then(result => {
      if (result.success) {
        this.importService.patch(this.boundImportId, this.boundImport).then(patchResult => {
          this.snackbar.success('Form successfully saved');
        });
      } else {
        const message = this.filterFormResults(result);
        console.log(result);
        this.snackbar.error('Could not safe! Hint: ' + message);
      }
    });
  }

  private copy() {
    const dublicatedImport = _.clone(this.boundImport) as Models.Import;
    dublicatedImport.title += '(copy)';
    delete dublicatedImport._id;
    delete dublicatedImport.created;

    return dublicatedImport.validate(true).then(result => {
      if (result.success) {
        return this.importService.create(<Models.Import>dublicatedImport).then(createResult => {
          this.router.navigate(['imports/' + createResult.getId() + '/edit']).then(() => console.log('naviagate to new import'));
        });
      } else {
        const message = this.filterFormResults(result);
        console.log(result);
        this.snackbar.error('Could not safe! Hint: ' + message);
      }
    });
  }

  private filterFormResults(result) {
    const error = result.results.filter(entry => {
      return !entry.success;
    });
    if (error && error[0].key) {
      if (error[0].results) {
        // the error has a sub Message from the validator
        return error[0].key + ' - ' + error[0].results[0].message;
      }
      return error[0].key + ' - ' + error[0].message;
    } else if (error[0].results) {
      // the error happens in a subModule
      return this.filterFormResults(error[0]);
    }
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'info',
        title: 'detail',
        callback: () => {
          this.router.navigate(['imports/', this.importId]);
        }
      }),
      new PageAction({
        icon: 'save',
        title: 'save',
        callback: () => {
          this.onSave();
        }
      }),
      new PageAction({
        icon: 'content_copy',
        title: 'copy Import',
        callback: () => {
          this.copy();
        }
      }),
      new PageAction({
        icon: 'cancel',
        title: 'cancel',
        callback: () => {
          this.router.navigate(['imports/', this.importId]);
        }
      }),
      new PageAction({
        icon: 'receipt',
        title: 'Logs',
        callback: () => {
          this.router.navigate(['import-logs/', 'importId', this.importId]);
        }
      }),
      new PageAction({
        icon: 'rowing',
        title: 'Execute',
        callback: () => {
          this.importService.patch(this.boundImportId, {}, { query: { execute: true } });
        }
      })
    ];
  }
}
